enum PathwayTypeEnum {
  PRACTICE = "Mastery Path",
  INSTRUCTION = "Builder Path"
}

export default PathwayTypeEnum;
